// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileWordFilledSvg from "@fishx/icons-svg/es/asn/FileWordFilled";
import FishxIcon from '../components/FishxIcon';

var FileWordFilled = function FileWordFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileWordFilledSvg
  }));
};

FileWordFilled.displayName = 'FileWordFilled';
export default React.forwardRef(FileWordFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileWordFilled.js
// module id = 2762
// module chunks = 0